import React from "react";
import { ConsumableMaterial } from "services/BillingEngineService/interfaces";
import { useQuery } from "react-query";
import { BillingEngineService } from "services";
import { useParams } from "react-router-dom";

interface SuppliesContextState {
  consumableMaterials: ConsumableMaterial[];
  status: string;
}

const SuppliesContext = React.createContext<SuppliesContextState | undefined>(undefined);

const SuppliesContextProvider: React.FC = ({ children }) => {
  const { organization_id: organizationId } = useParams<any>();

  const { data: consumableMaterials = [], status } = useQuery(
    ["consumableMaterials", organizationId],
    () => BillingEngineService.getConsumableMaterials(organizationId),
    {
      refetchOnWindowFocus: false,
    }
  );

  return (
    <SuppliesContext.Provider
      value={{
        consumableMaterials: consumableMaterials,
        status,
      }}
    >
      {children}
    </SuppliesContext.Provider>
  );
};

const useSuppliesContext = () => {
  const context = React.useContext(SuppliesContext);

  if (!context) {
    throw new Error("useSuppliesContext can be used only inside <SuppliesContextProvider />");
  }

  return context;
};

export { SuppliesContextProvider, useSuppliesContext };
